import React, {useCallback, useState, useEffect} from 'react'
import PropTypes from 'prop-types';
import FullCalendar from '@fullcalendar/react'
import Moment from 'moment'
import { Popup } from 'semantic-ui-react'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import './styles.less'
import dayGridPlugin from '@fullcalendar/daygrid'
import SchedulerPopup from '../TapeChart/popup'
import { isBrowser, isMobileOnly } from 'mobile-device-detect';
/* CSS imports */
// import '@fullcalendar/core/main.css'
// import '@fullcalendar/timeline/main.css'
// import '@fullcalendar/resource-timeline/main.css'
import ApartmentOwnerReservationsList from './ApartmentOwnerReservationsList';
import ApartmentOwnerReservationItem from './ApartmentOwnerReservationItem';
import ApartmentOwnerMaintainance from "./ApartmentOwnerMaintainance";
import { MaintenanceStatusTypes } from '../../components/shared/statustypes';
import {
	currencyFormat
} from '../../components/shared/utils';
import formatCurrency from 'format-currency';

const ApartmentOwnersPortalCalendar = (props) => {

    const [popupReservaion, setPopupReservaion] = useState(null)
    const [showPopup, setShowPopup] = useState(true)
    const [popupContext, setPopupContext] = useState(null)
    const [chosenReservationDetails, setChosenReservationDetails] = useState(null);
    const calendarRef = React.createRef()
    const [displayTooltip, setDisplayTooltip] = useState(false)
    const [tooltipContext, setTooltipContext] = useState(null)
    const [tooltipContent, setTooltipContent] = useState(null)
    const [tooltipHeader, setTooltipHeader] = useState(null)
    const [tooltipPosition, setTooltipPosition] = useState("left center")
    const [chosenMaintainance, setChosenMaintainance] = useState(null);
    
    useEffect(() => {
        let calendarApi = calendarRef.current.getApi()
        window.AO_calendar = calendarApi
    }, [calendarRef])
    
    const eventRender = useCallback(info => {
        let el = info.el
       
            const reservation = info.event.extendedProps.reservation
            if (reservation) {             
            el.setAttribute('data-event-id', info.event.id)
        }
    }, [])

    const GetReservationDetails = (event) => {
        if(event.extendedProps.reservation){
            const totals = event.extendedProps.totals
            let price = formatCurrency(totals.TotalAmountDebitAfterTax,currencyFormat(totals.CurrencyID))
            return {...event.extendedProps.reservation, price}
        }
        return null
    }

    const eventMouseEnter = useCallback(info => {
        const reservation = GetReservationDetails(info.event);
        const maintenance = info.event.extendedProps.maintenance;
        if(isBrowser){
            if (reservation) {
                setPopupContext(info.el)
                setPopupReservaion(reservation)
                setShowPopup(true)
            } else if (maintenance) {
                showTootip(info.el, maintenance.Description, "top center", MaintenanceStatusTypes[maintenance.MaintenanceStatusTypeId])
            }
        }
    }, [])

    const eventMouseLeave = useCallback(info => {
        const reservation = GetReservationDetails(info.event);
        const maintenance = info.event.extendedProps.maintenance
        if(isBrowser){
            if (reservation) {
                setPopupContext(null)
                setShowPopup(false)
            }
            else if (maintenance) {
                hideTootip()
            }
        }
    }, [])

    const showTootip = (context, content, position, header) => {
        setTooltipContext(context)
        setTooltipContent(content)
        setTooltipPosition(position)
        setTooltipHeader(header)
        setDisplayTooltip(true)
    }
    const hideTootip = () => {
        setDisplayTooltip(false)
        setTooltipContext(null)
        setTooltipContent(null)
        setTooltipHeader(null)
    }

    const eventClick =  useCallback(info => {
        const reservation = GetReservationDetails(info.event);
        const maintenance = info.event.extendedProps.maintenance;
        if(isMobileOnly){
            if (reservation) {
                setChosenReservationDetails(reservation);
                setChosenMaintainance(null);
            } else if (maintenance) {
                setChosenMaintainance(maintenance);
                setChosenReservationDetails(null);
            }
        }
    }, [])


    return (
        <div className="apartment-owner-calendar">
            <FullCalendar 
                locale={props.calendarLanguage}
                ref={calendarRef}
                defaultView="dayGridMonth" 
                schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
                defaultDate={moment().toDate()}
                eventOverlap={false} 
                displayEventTime={false}
                header={{
                    right: "prev,next",
                    left: "title"
                  }}
                refetchResourcesOnNavigate={true} 
                plugins={[ dayGridPlugin ]} 
                eventRender={eventRender} 
                eventClick={eventClick}
                eventMouseEnter={eventMouseEnter} 
                eventMouseLeave={eventMouseLeave} 
                initialEvents={ props.eventsFunction}
                eventSources={[
                    {
                        id: "main",
                        events: props.eventsFunction
                    }
                ]}
            />
        {
            isBrowser && 
            <SchedulerPopup open={showPopup} context={popupContext} reservation={popupReservaion} displayPrice={props.displayPrice}/>
        }
        {
            isBrowser &&
            <Popup open={displayTooltip} context={tooltipContext} header={tooltipHeader} content={tooltipContent} position={tooltipPosition} />
        }
        {
            isMobileOnly && props.reservations && props.reservations.length > 0 && chosenMaintainance == null && chosenReservationDetails == null &&
            <ApartmentOwnerReservationsList reservations={props.reservations} />
        }
        {
            isMobileOnly && chosenReservationDetails != null &&
            <ApartmentOwnerReservationItem item={chosenReservationDetails} displayPrice={props.displayPrice}/>
        }
        {
            isMobileOnly && chosenMaintainance != null &&
            <ApartmentOwnerMaintainance item={chosenMaintainance}/>
        }
        </div>
    )
}

ApartmentOwnersPortalCalendar.propTypes = { 
    RoomID:PropTypes.number,
    ApartmentOwnerID: PropTypes.number,
    eventsFunction: PropTypes.func.isRequired,
    setViewSettings: PropTypes.func,
    reservations: PropTypes.array,
    calendarLanguage: PropTypes.object,
    displayPrice: PropTypes.bool
}

export default ApartmentOwnersPortalCalendar
